<template>
  <div class="thumb portrait">
    <a href="javascript:void(0)">
      <div v-if="checkValidRank" class="rank-area" aria-hidden="true">
        <img :src="rankingImgUrl" :alt="rankingImgAlt" />
      </div>
      <div class="thumb-image">
        <div class="picture-area">
          <WebpImage :imageInfo="{imageUrl: cellInfo.thumbnail, width: thumbnailInfo.width, height: thumbnailInfo.height, alt: altTitle, className: 'thumb-img', onImageLoad}" />
        </div>
        <div
          class="no-thumb"
          :aria-hidden="!isImageLoaded"
          :style="`display: ${displayCss}`"
        >
          <span class="alt-text">{{ alt }}</span>
        </div>
        <ul class="badge-list">
          <li class="left-top-area">
            <ul v-top-tag-list="topTagList"></ul>
          </li>
          <li class="right-top-area" v-common-tag-list="{'badgeList': brandTagList, 'type': 'brand'}"></li>
        </ul>
      </div>
      <div class="sub-title a11y-hidden">
        <div
          class="sub-right"
          v-title-list="{
            titleList: titleList,
            cellType: 'portrait',
            callback: loaded,
          }"
        ></div>
      </div>
    </a>
  </div>
</template>
<script>
import _ from 'lodash'
import {
  bandTitle,
  titleList,
  commonTagList,
  topTagList
} from '@/common/resources/directives'
import CellMixIn from '@/mixins/cell.mixin'
import shave from 'shave'
import WebpImage from '@/components/image/WebpImage'
export default {
  name: 'PortraitRankingCell',
  components: { WebpImage },
  mixins: [CellMixIn],
  directives: {
    bandTitle,
    titleList,
    commonTagList,
    topTagList
  },
  props: {
    cellInfo: {
      type: Object
    },
    sectionInfo: {
      type: Object
    },
    thumbnailInfo: {
      type: Object
    },
    cellIndex: {
      type: Number
    }
  },
  computed: {
    rankValue () {
      return this.cellInfo?.rank ?? ''
    },
    checkValidRank () {
      const candidate = Array.from({ length: 20 }, (_, i) => `${(i + 1)}`)
      return candidate.findIndex((el) => el === this.rankValue) !== -1
    },
    rankingImgUrl () {
      return this.checkValidRank ? require(`@/assets/images/main/element-icons-120-x-76-ic-rank-${this.rankValue}@3x.png`) : ''
    },
    rankingImgAlt () {
      return this.checkValidRank ? `랭킹 ${this.rankValue}위` : ''
    }
  },
  methods: {
    loaded (el) {
      this.$nextTick(() => {
        _.forEach(el.querySelectorAll('.line1'), (line1El) => {
          shave(line1El, 28)
        })
      })
    }
  }
}
</script>
<style lang="scss" src="@/assets/scss/import/portrait.scss"></style>
